import {
  Award,
  CircleDollarSign,
  Globe,
  Lock,
  Map as MapIcon,
  Palette,
  Settings2,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export type TabKey =
  'basic' | 'access' | 'design' | 'pricing' | 'map' | 'languages' | 'certificates'

export interface TabDef {
  key: TabKey
  label: string
  icon: LucideIcon
  title: string
  description: string
  soon?: boolean
}

type Text = (typeof messages)['ru']
type Field = 'Label' | 'Title' | 'Description'
type TextKey = keyof Text & `tab${string}${Field}`

const read = (key: TabKey, field: Field): string => {
  const name = `tab${key[0].toUpperCase()}${key.slice(1)}${field}` as TextKey
  return messagesNow(messages)[name] as string
}

/** Тексты вкладки — геттерами: `TABS` остаётся константой, а подписи читаются на
 *  языке интерфейса в момент рендера. */
const tab = (key: TabKey, icon: LucideIcon, soon?: true): TabDef => ({
  key,
  icon,
  ...(soon ? { soon } : {}),
  get label() {
    return read(key, 'Label')
  },
  get title() {
    return read(key, 'Title')
  },
  get description() {
    return read(key, 'Description')
  },
})

export const TABS: TabDef[] = [
  tab('basic', Settings2),
  tab('access', Lock),
  tab('design', Palette),
  tab('pricing', CircleDollarSign),
  tab('map', MapIcon),
  tab('languages', Globe),
  tab('certificates', Award, true),
]
